import React from "react";

const IconRedCard = ({ className }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="9" cy="11" r="9" transform="translate(0 -2)" fill="#D0021B" fillRule="nonzero" />
  </svg>
);

export default IconRedCard;
